import { ProgressBar, Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SitePerformanceRiskRankingTable = ({
  userActivityLoader,
  userActivity = [],
}) => {
  return (
    <>
      {userActivityLoader ? (
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader />
        </div>
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Site</th>
              <th>Total</th>
              <th>Open</th>
              <th>Closed</th>
              <th>Overdue</th>
              <th>Re-Opened</th>
              <th>Avg Resp</th>
              <th>Avg Close</th>
              <th>Q/Subject</th>
              <th>Oldest</th>
              <th>SLA Compliance</th>
              <th>Risk</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Site 02 — Mumbai</td>
              <td>306</td>
              <td>41</td>
              <td>241</td>
              <td>54</td>
              <td>19</td>
              <td>8.7 d</td>
              <td>12.6 d</td>
              <td>11.77</td>
              <td>175 d</td>
              <td>
                <ProgressBar
                  style={{ height: 4 }}
                  className="border"
                  variant="warning"
                  now={31}
                />
                <div className="text-end">{`31%`}</div>
              </td>
              <td>High</td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
};

export default SitePerformanceRiskRankingTable;
